import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import ParentHead from '../components/Header/ParentHead'
import Hero from '../components/sections/Hero'
// import Headline from '../components/sections/Headline'
import Features from '../components/sections/Features'
import Testimonials from '../components/sections/Testimonials'
import Footerform from '../components/sections/Footerform'
import Footer from '../components/sections/Footer'

export default class IndexPage extends React.Component {
  render() {
    const { path, data: { HomePageData } } = this.props
    const { edges: [{ node: { frontmatter: HomeData } }] } = HomePageData
    return (
      <Layout>
        <ParentHead path={path}/>
        <Hero
          title={HomeData.title}
          bannerTitle={HomeData.bannerTitle}
          bannerDesc={HomeData.bannerDesc}
          bannerDescHighLight={HomeData.bannerDescHighLight}
          bannerImage={HomeData.bannerImage}
          bannerVideo={HomeData.bannerVideo}
          showVideo={HomeData.showVideo}
          bannerGif={HomeData.bannerGif}
          buttonText={HomeData.buttonText}
          buttonUrl={HomeData.buttonUrl}
          earlyAccessRef='Home Page Banner'
        />
        <div id="features"></div>
        <Features
          allFeatures={HomeData.features}
          featureTitle={HomeData.featureTitle}
          buttonText={HomeData.buttonText}
          buttonUrl={HomeData.buttonUrl}
        />
        <Testimonials
          testimonial={HomeData.testimonial} />
        <Footerform
          footerFormTitle={HomeData.footerFormTitle}
          bgColor={true}
          buttonText={HomeData.buttonText}
          buttonUrl={HomeData.buttonUrl}
          earlyAccessRef='Home Page Footer'
        />
        <div id="contact-us"></div>
        <Footer
          buttonText={HomeData.buttonText}
          buttonUrl={HomeData.buttonUrl}
          allsocialUrls={HomeData.socialUrls}
          bgColor={false}
          path={path}
        />
      </Layout>
    )
  }
}

IndexPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export const pageQuery = graphql`
  query IndexQuery {
    HomePageData: allMarkdownRemark(filter: {frontmatter: {templateKey: {eq: "pirlo"}}}) {
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            title
            bannerTitle
            bannerDesc
            bannerDescHighLight
            bannerImage
            bannerVideo
            showVideo
            bannerGif
            buttonText
            buttonUrl
            featureTitle
            features {
              title
              desc
              icon
            }
            testimonial{
              title
              list{
                name
                profile
                content
                image
                socialUrls{
                  fbUrl
                  whatsAppUrl
                  xapoUrl
                  linkedin
                  twitterUrl
                  instagramUrl
                }
              }
            }
            faq{
              faqs{
                title
                desc
              }
            }
            footerFormTitle
            socialUrls{
              fbUrl
              linkedin
              twitterUrl
              instagramUrl
            }
          }
        }
      }
    }
  }
`
